const IS_DEV = import.meta.env.MODE === 'development';
const IS_TEST = import.meta.env.MODE === 'test';
const IS_PROD = import.meta.env.MODE === 'production' || import.meta.env.MODE === 'stage';

function isQueryEqual(key: string, value: string) {
  if (!window.location || !window.location.search) return false;
  return new URLSearchParams(window.location.search).get(key) === value;
}

const FEATURES = {
  /** 阵列功能 */
  ENABLE_MODEL_ARRAY: IS_DEV,
  /** 对齐功能 */
  ENABLE_MODEL_ALIGN: IS_DEV,
  /** 框选切换选中状态 */
  ENABLE_RECT_SElECT_TOGGLE: IS_DEV,
  /** 多选同款替换功能 */
  ENABLE_MULTI_MODEL_REPLACE: IS_DEV,
  /** 新版方案管理：文件夹/回收站/历史版本/复制移动另存 */
  ENABLE_SCHEME_MANAGE_V1: false,
  /** 测量功能 */
  ENABLE_MEASURE: IS_DEV,
  /** 弧形墙绘制 */
  ENABLE_ARC_WALL: IS_DEV,
  /** 弧形隔墙 */
  ENABEL_ARC_SEP_WALL: IS_DEV,
  /** 隔墙端点拖动 */
  ENABLE_SEP_WALL_POINT_DRAG: IS_DEV,
  /** 选择同款构件 */
  ENABLE_SELECT_SAME_MODELS: IS_DEV,
  /** 新版本快捷键 */
  ENABLE_SHORTCUT_V1: IS_DEV,
  /** DXF 底图图层管理 */
  ENABLE_DXF_LAYER: IS_DEV,
  /** 显隐面板部分隐藏三态、「标尺」和「底图」改为默认隐藏 */
  ENABLE_VISIBLE_V1: IS_DEV,
  /** 团队功能：成员文件管理 */
  ENABLE_TEAM_MEMBER_FILE: IS_DEV,
  /** 管理后台：概算单价 */
  ENABLE_ADMIN_UNIT_PRICE: IS_DEV,
  /** 家具库实时搜索 */
  ENABLE_LIB_REALTIME_SEARCH: IS_DEV,
  /** 对象菜单位置优化 */
  CTX_MENU_POS_OPTIMIZE: IS_DEV,
  /** 自动布局按面积追加的最短等待 */
  ENABLE_LAYOUT_MIN_WAIT: IS_PROD
} as const;

const FEATURES_DEV = {
  /** 显示坐标轴 */
  ENABLE_AXIS: IS_DEV,
  /** i18next Debug 模式 */
  ENABLE_I18N_DEBUG: false,
  /** 自动布局结果列表 */
  ENABLE_LAYOUT_RESULT_LIST: true,
  /** 自动布局数据预览 */
  ENABLE_LAYOUT_DATA_PREVIEW: !IS_PROD,
  /** CAD 识别内容导入 */
  ENABLE_CAD_IMPORT: !IS_PROD && isQueryEqual('cadImport', '1'),
  /** 截图性能探测：分阶段耗时/绘制量/输出体积输出到控制台，并附带一张预览图 */
  ENABLE_CAPTURE_PERF: IS_DEV
};

export const FLAGS = {
  FEATURES,
  FEATURES_DEV,
  IS_DEV,
  IS_TEST,
  IS_PROD
};
